import React, {useState} from "react";
import Offcanvas from "react-bootstrap/Offcanvas";
import Nav from "react-bootstrap/Nav";
import {Menu} from "./Menu";
import {Button} from "./global/Button";
import {useACFOptions} from "./_hooks/useACFOptions";
import introImg from "../images/rbtc/bitcoin.svg";

export const OffCanvasMenu = ({copy, contact}) => {
  const [show, setShow] = useState(false);
  
  const {header} = useACFOptions();;
  const bridge = header?.bridgeLink;


  const handleToggle = () => setShow(!show);
  return (
    <>
      <button
        className={`btn d-inline-flex d-lg-none justify-content-end zg-burger ${show ? 'close' : ''}`}
        type="button"
        aria-label="menu toggle"
        onClick={handleToggle}>
      </button>
      <Offcanvas
        className="bg-black d-lg-none"
        show={show}
        backdrop={false}
        placement="end">
        <Offcanvas.Body>
          <Nav className="me-lg-auto">
            <Menu/>
          </Nav>
          <div className="d-flex-col">
         <a className="btn btn-outline-white btn-sm w-100 mt-5 btn-lg mb-5" rel="noopener noreferrer" href={bridge.url}>
              {bridge.title} <img src={introImg} className="rbtc icon" alt="rbtc icon" width="33" height="33" loading="lazy"/>
          </a>
              </div>

          {copy && (
            <p className="mt-auto mb-0 text-center fs-7 opacity-25" dangerouslySetInnerHTML={{__html:copy}}></p>
          )}
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};
